<template>
  <v-dialog v-model="isOpen" persistent max-width="450">
    <v-card class="align-center text-center">
      <v-card-title class="headline justify-center"> Agrupamento de {{ bodyText }} </v-card-title>
      <div v-if="bodyText == 'Cargas'">
        <v-card-text class="text-left text-subtitle-1 font-weight-regular pt-4">
          Agrupar por cidade dos Transbordos:</v-card-text
        >
        <v-card-text class="d-flex align-center text-left">
          <div class="d-flex mr-5">
            <v-simple-checkbox :value="true" disabled class="simple-checkbox"></v-simple-checkbox>
            <span class="text-subtitle-1 font-weight-regular">Transferência</span>
          </div>
        </v-card-text>
      </div>
      <div v-else>
        <v-card-text class="text-left text-subtitle-1 font-weight-regular pt-4"> Agrupar por CPF/CNPJ:</v-card-text>
        <v-card-text class="d-flex align-center text-left">
          <div class="d-flex mr-5">
            <v-simple-checkbox :value="true" disabled class="simple-checkbox"></v-simple-checkbox>
            <span class="text-subtitle-1 font-weight-regular">Destinatário</span>
          </div>
          <div class="d-flex">
            <v-simple-checkbox :value="true" disabled class="simple-checkbox"></v-simple-checkbox>
            <span class="text-subtitle-1 font-weight-regular">Remetente</span>
          </div>
        </v-card-text>
      </div>
      <v-card-actions class="d-flex justify-space-between pb-5">
        <v-btn @click="$emit('update:isOpen'), $emit('cancelClick')" color="error" class="flex-grow-1">
          Cancelar
        </v-btn>
        <v-btn :loading="isConfirmBtnLoading" @click="$emit('confirmClick')" color="success" class="flex-grow-1">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpen: {
      default: true,
      type: Boolean
    },
    confirmButtonText: {
      default: 'Confirmar',
      type: String
    },
    confirmText: {
      default: 'Confirmar',
      type: String
    },
    bodyText: {
      default: 'entregas',
      type: String
    },
    isConfirmBtnLoading: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style scoped>
.simple-checkbox .v-input--selection-controls__input {
  margin-right: 2px;
}
</style>
